import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'

export interface AuthorTagProps extends HTMLAttributes<HTMLDivElement> {}

export default function AuthorTag({ ...props }: AuthorTagProps) {
	return (
		<div
			{...props}
			css={css`
				display: inline-flex;
				justify-content: center;
				align-items: center;
				min-width: 20px;
				font-size: 12px;
				font-weight: 400;
				line-height: 1.2;
				border-radius: 15px;
				padding: 2px 5px;
				color: var(--tint-secondary);
				border: 1px solid var(--tint-separator);
			`}
		>
			作者
		</div>
	)
}
